import { useAtomValue } from 'jotai'
import { userInfoAtom } from '../../../../data/atoms/utilsAtoms'
import { ROLES } from '../../../../constants/userRoles'

const GetUserRole = () => {
const userData = useAtomValue(userInfoAtom)
const userType = userData?.user?.userType;
const roleType = userData?.user?.roleType;

const userRole = userType && userType.trim() !== "" ? userType : roleType;

return ROLES[userRole] || "";
}

export default GetUserRole